import { api } from './api';

export type WallStatus = 'active' | 'lifted';

export interface WallMatterRef {
  id: string;
  caseNumber: string;
  caseName: string;
}

export interface EthicalWall {
  id: string;
  chambersId: string;
  status: WallStatus;
  reason: string | null;
  notifiedSolicitorsAt: string | null;
  erectedById: string;
  erectedAt: string;
  liftedById: string | null;
  liftedAt: string | null;
  matterA: WallMatterRef;
  matterB: WallMatterRef;
}

export async function fetchWalls(status?: WallStatus): Promise<EthicalWall[]> {
  const res = await api.get('/ethical-walls', { params: status ? { status } : {} });
  return res.data.data as EthicalWall[];
}

export async function fetchWallsForMatter(matterId: string): Promise<EthicalWall[]> {
  return (await api.get(`/ethical-walls/for-matter/${matterId}`)).data.data as EthicalWall[];
}

export async function erectWall(input: {
  matterAId: string;
  matterBId: string;
  reason?: string;
  solicitorsNotified?: boolean;
}): Promise<EthicalWall> {
  return (await api.post('/ethical-walls', input)).data.data as EthicalWall;
}

export async function liftWall(id: string, reason?: string): Promise<EthicalWall> {
  return (await api.post(`/ethical-walls/${id}/lift`, { reason })).data.data as EthicalWall;
}
